'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdExposurePlus2 = function MdExposurePlus2(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm13.4 11.6v6.8h6.6v3.2h-6.6v6.8h-3.4v-6.8h-6.6v-3.2h6.6v-6.8h3.4z m13.3 15.6h9.9v2.8h-14.3v-2.5l6.9-7.6q1.4-1.4 2.4-3.1 0.7-1 0.7-2.2 0-1.2-0.9-2.4-0.8-1-2.3-1-1.7 0-2.8 1.1-0.8 0.8-0.8 2.7h-3.6q0-2.8 1.8-4.7 1.1-1.1 2.3-1.5 1.4-0.4 3.1-0.4 1.4 0 2.8 0.3 1.6 0.7 2.2 1.2 1.8 1.6 1.8 4.3 0 1.9-1.3 3.9-0.9 1.6-1.3 2-1.1 1.2-1.8 1.9z' })
        )
    );
};

exports.default = MdExposurePlus2;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/exposure-plus-2.js
// module id = 970
// module chunks = 36573943044255 79611799117203 213534597649335